import PageStyle from "@/styles/pages/errors/_index.module.scss";
import Image from 'next/image';
import { useEffect, useState } from '@/imports-files/common/common';

export default function Error500(){
  const [error, setError] = useState(false)
  useEffect(() => {
    setTimeout(() => setError(true), 1000)
  }, [])

  return (
    <div className={`${PageStyle.NewJob}`}>
      <div className={PageStyle.NewJob__Container}>
        {error && <div className={PageStyle.Error}>
          <Image src='/images/errors/500.png' height={153} width={293} alt=''></Image>

          <h1>500</h1>

          <h3>Something went wrong!!</h3>
        </div>}
      </div>
    </div>
  )
}
